// src/App.js
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { useState, useEffect, createContext, useContext } from "react";
import { onAuthChange, isAllowed } from "./auth";
import Home      from "./pages/Home";
import RecipePage from "./pages/RecipePage";
import EditPage  from "./pages/EditPage";
import "./index.css";

export const AuthContext = createContext(null);
export function useAuth() { return useContext(AuthContext); }

export default function App() {
  const [user, setUser] = useState(undefined);

  useEffect(() => {
    return onAuthChange(u => setUser(u || null));
  }, []);

  if (user === undefined) return null; // loading

  return (
    <AuthContext.Provider value={{ user, allowed: isAllowed(user) }}>
      <BrowserRouter>
        <Routes>
          <Route path="/"           element={<Home />} />
          <Route path="/recipe/:id" element={<RecipePage />} />
          <Route path="/new"        element={<EditPage />} />
          <Route path="/edit/:id"   element={<EditPage />} />
        </Routes>
      </BrowserRouter>
    </AuthContext.Provider>
  );
}
